export const navItems = [
    {
        id: '1',
        links: [
            {
                id: 'instant',
                linkText: 'Instant',
                to: '/setup/integration/instant',
            },
            {
                id: 'zapier',
                linkText: 'Zapier',
                to: '/setup/integration/zapier',
            },
        ],
    },
    {
        id: '2',
        label: ' ', // Empty label makes horizontal rule appear
        links: [
            {
                id: 'all',
                linkText: 'All integrations',
                to: '/setup/integration/all',
            },
            {
                id: 'accounting',
                linkText: 'Accounting',
                to: '/setup/integration/accounting',
            },
            {
                id: 'collaboration',
                linkText: 'Collaboration',
                to: '/setup/integration/collaboration',
            },
            {
                id: 'communication',
                linkText: 'Communication & phone',
                to: '/setup/integration/communication',
            },
            {
                id: 'contracts',
                linkText: 'Contracts & proposals',
                to: '/setup/integration/contracts',
            },
            {
                id: 'forms',
                linkText: 'Forms',
                to: '/setup/integration/forms',
            },
            {
                id: 'lead-generation',
                linkText: 'Lead generation',
                to: '/setup/integration/lead_generation',
            },
            {
                id: 'scheduling',
                linkText: 'Scheduling',
                to: '/setup/integration/scheduling',
            },
            {
                id: 'webinars',
                linkText: 'Webinars & events',
                to: '/setup/integration/webinars',
            },
            {
                id: 'other',
                linkText: 'Other',
                to: '/setup/integration/other',
            },
        ],
    },
    {
        id: '3',
        label: ' ', // Empty label makes horizontal rule appear
        links: [
            {
                id: 'custom-quote',
                linkText: 'Custom quote',
                to: '/setup/integration/custom-quote',
            },
        ],
    },
] as const;
